import { UserBonus } from 'config/types/bonus/userBonus'
import { RowCenter, RowMiddle } from 'layout/Components/Row'
import React from 'react'
import CopyButton from 'UIKit/Button/CopyButton'
import Text from 'UIKit/Text'
import { encodeIdToBase36 } from './utils'

interface TxIDBonusSectionProps {
  bonus: UserBonus
}

const TxIDBonusSection: React.FC<TxIDBonusSectionProps> = ({ bonus }) => {
  const txId = encodeIdToBase36(bonus.id)

  return (
    <RowMiddle gap="4px" mt="5px">
      <Text
        textAlign="right"
        fontWeight={500}
        fontSize="12px"
        color="textAlt1"
        ellipsis={3}
        wordBreak="break-all"
        width="fit-content"
      >
        {txId}
      </Text>

      <RowCenter>
        <CopyButton iconSize={12} text={txId} />
      </RowCenter>
    </RowMiddle>
  )
}

export default TxIDBonusSection
